import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Picto } from '@app/core/business/product/picto';
import { environment } from '@env/environment';
import { interval, timer } from 'rxjs';

@Component({
  selector: 'app-picto',
  templateUrl: './picto.component.html',
  styleUrls: ['./picto.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PictoComponent implements OnInit {

  @Input()
  picto : Picto;

  public env = environment;

  public extension: string = ".png";
  
  constructor() { 
  }

  ngOnInit(): void {   
  }
}
